import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Nav from "../components/nav"
import AboutContent from "../components/content/about"
import Footer from "../components/footer"

const AboutPage = () => (
  <>
    <SEO title="About" />
    <Nav />
    <AboutContent />
    <Footer />
  </>
)

export default AboutPage
